import axios from "axios";

let language = document.documentElement.lang;

export default {
    get(data) {
        const API = `/api/payment/PaymentBanks`;
        const headers = {
            "currency": localStorage.getItem("currency")
        };

        return new Promise((resolve, reject) => {
            axios.post(API, { Amount: data }, { headers: headers }).then(res => {
                    resolve(res.data);
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
};